/**
 * The Wally palette, named by role. Values are the Style Library's, exactly.
 *
 * The names are the contract: code says what a colour is for, never which slot it sits in, so a
 * screen cannot quietly reach for "the pink one" when it means the ground. There is no dark mode.
 */
const colors = {
	/** Surfaces on the ground: cards, rows, inputs. */
	white: '#FFFFFF',
	/** The page. Everything sits on this pink. */
	ground: '#FECAC9',
	/** A solid light grey: a switch track, a sheet's grabber. */
	line: '#E2DFDF',
	/**
	 * An outline: inputs, the composer, a choice, the rule through a chat's time label. Not
	 * named hairline, which NativeWind reads as a border width on every side.
	 */
	edge: 'rgba(125,111,111,0.45)',
	/** A divider between rows: the same grey as edge, lighter, so a list reads as one card. */
	divider: 'rgba(125,111,111,0.22)',
	/** A disabled input's fill, and the quiet grey ground of a white surface's inner panel. */
	surface: '#F9F9F9',
	/** The brand's light pink: a disabled button on the ground, a skeleton, a soft panel. */
	blush: '#FFE9E9',
	/** A note left on the counter: the warm off-white every card sits on. */
	note: '#FFF8F6',
	/** The second line of anything: an address under a time, a date under a title. */
	softInk: '#665858',
	/** A hairline on the pink, the colour of a fold in the paper. */
	rule: '#F0B9B8',
	/** Text, chrome, the emphasis surface. */
	ink: '#000000',
	/** The one action a screen leads with. Once per screen. */
	accent: '#F96B60',
	/** Focus and pressed only. Never a resting colour. */
	focus: '#4B43E2',
	/** Errors. */
	danger: '#F92E32',
	/** The promo strip green: success. */
	mint: '#CDF6D9',
	/** The dot that says "live" on a mint pill. Mint alone is too pale to read as a dot. */
	leaf: '#2E9E63',
	/** Inactive labels, placeholders, disabled borders. */
	muted: '#767676',
	/** The native splash background. Not a brand colour; kept for the launch screen only. */
	splash: '#006A5C',
} as const

export { colors }
module.exports = { colors }
